<template>
<div/>
</template>

<script>
  import Modal from '@/components/Modal.vue'

  export default {
    name: 'error-modal',

    components: {
      Modal
    },

    props: {
      text: {
        type: String,
        required: true
      },
      errorId: {
        type: String,
        required: false
      }
    },
    created() {
      this.$noty.error(this.text)
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/colors.scss";
  .error-id {
    font-size: 10px;
    color: #cccccc;
    margin-top: 15px;
  }
</style>
